// extracted by mini-css-extract-plugin
export default {"login-form":"Login_login-form__NGFRi","button":"Login_button__RDp5+"};